'use client';

import { HStack } from '@terra/ui-styled-system';
import { MetaDefault, Spinner } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import {
  resolveTorchAssetsBannerPhase,
  TORCH_ASSETS_BANNER_PHASE,
} from '../../utils/torch-assets-banner-phase';

type TorchDiscoveryBannerProps = {
  isDiscoveryActive: boolean;
  isProcessingActive: boolean;
  isDeduplicationActive?: boolean;
  isDeduplicationEnabled?: boolean;
  assetTypeFilter?: string;
  relevantProcessingAssetTypes?: string[];
};

export function TorchDiscoveryBanner({
  isDiscoveryActive,
  isProcessingActive,
  isDeduplicationActive,
  isDeduplicationEnabled,
  assetTypeFilter,
  relevantProcessingAssetTypes,
}: TorchDiscoveryBannerProps) {
  const t = useTranslations('assetsTab');

  const phase = resolveTorchAssetsBannerPhase({
    isDiscoveryActive,
    isParametrizationActive: isProcessingActive,
    isDeduplicationActive: isDeduplicationActive ?? false,
    isDeduplicationEnabled: isDeduplicationEnabled ?? false,
    assetTypeFilter,
    relevantProcessingAssetTypes,
  });

  if (!phase) {
    return null;
  }

  const label =
    phase === TORCH_ASSETS_BANNER_PHASE.parametrization
      ? t('parametrizationInProgress')
      : phase === TORCH_ASSETS_BANNER_PHASE.deduplication
        ? t('deduplicationInProgress')
        : t('discoveryInProgress');

  return (
    <HStack
      gap={2}
      alignItems="center"
      mx={3}
      mt={3}
      mb={1}
      px={3}
      py={1.5}
      borderRadius="md"
      bg="bg.muted"
      flexShrink={0}
    >
      <Spinner size="xs" colorPalette="gray" />
      <MetaDefault color="fg.default">{label}</MetaDefault>
    </HStack>
  );
}
